/**
 * Превью подложек поля: идентификатор подложки -> маленькая картинка для экрана
 * выбора подложки (см. configs/groundBackgroundChoice).
 *
 * ФАЙЛ ЦЕЛИКОМ ПИШЕТ СКРИПТ developer_artifacts/scripts/generateGroundBackgroundPreviews.cjs,
 * руками его не правят: в имени превью — отпечаток исходной картинки, и тест
 * сверяет его с подложкой на диске. Добавили, сняли или перерисовали подложку —
 * запусти скрипт.
 */
export const GROUND_BACKGROUND_PREVIEW_PATHS = Object.freeze({
  magical_forest_2: '/img/ground/previews/magical_forest_2.43406e35.jpg',
  salt_1: '/img/ground/previews/salt_1.f7212019.jpg',
  green_1: '/img/ground/previews/green_1.6611fe93.jpg',
  green_2: '/img/ground/previews/green_2.22002565.jpg',
  green_3: '/img/ground/previews/green_3.591c7108.jpg',
  green_4: '/img/ground/previews/green_4.a94deb44.jpg',
  desert_1: '/img/ground/previews/desert_1.7bb39f2e.jpg',
  desert_2: '/img/ground/previews/desert_2.3476bba0.jpg',
  winter_1: '/img/ground/previews/winter_1.b9fbf51b.jpg',
  winter_2: '/img/ground/previews/winter_2.9347b861.jpg',
  winter_3: '/img/ground/previews/winter_3.e27bbf3b.jpg',
  winter_4: '/img/ground/previews/winter_4.c2dfb81f.jpg',
  winter_5: '/img/ground/previews/winter_5.aacdd44d.jpg',
  demon_1: '/img/ground/previews/demon_1.36b74ac6.jpg',
  ash_1: '/img/ground/previews/ash_1.a1e9fa1e.jpg',
  geyser_1: '/img/ground/previews/geyser_1.a2355186.jpg',
  bone_1: '/img/ground/previews/bone_1.1b4f78eb.jpg',
  island_1: '/img/ground/previews/island_1.2dc23710.jpg',
  red_1: '/img/ground/previews/red_1.e81881cb.jpg',
  volcano_1: '/img/ground/previews/volcano_1.1932d43a.jpg',
  bog_1: '/img/ground/previews/bog_1.74ada5d0.jpg',
  mushroom_1: '/img/ground/previews/mushroom_1.d1bd4624.jpg',
  plato_1: '/img/ground/previews/plato_1.5380d3c5.jpg',
  rice_1: '/img/ground/previews/rice_1.8c48ec8d.jpg',
  spiral_1: '/img/ground/previews/spiral_1.4416098c.jpg',
});
